import {PricesViewType} from "../helpers/prices_view_type";

export const getPricesTextFromType = (type: PricesViewType) => {
    switch (type) {
        case PricesViewType.FLATS:
            return "ceny mieszkań";
        case PricesViewType.HOUSES:
            return "ceny domów";
        case PricesViewType.ALL:
            return "ceny nieruchomości";
        default:
            throw new Error("Unknown prices view type");
    }
};

export const getAvgPricesText = (type?: PricesViewType) => {
    switch (type) {
        case PricesViewType.FLATS:
            return "średnie ceny mieszkań";
        case PricesViewType.HOUSES:
            return "średnie ceny domów";
        case PricesViewType.ALL:
            return "średnie ceny nieruchomości";
        default:
            return "średnie ceny";
    }
};
import {PricesViewType} from "../helpers/prices_view_type";

export const getPricesTextFromType = (type: PricesViewType) => {
    switch (type) {
        case PricesViewType.FLATS:
            return "ceny mieszkań";
        case PricesViewType.HOUSES:
            return "ceny domów";
        case PricesViewType.ALL:
            return "ceny nieruchomości";
        default:
            throw new Error("Unknown prices view type");
    }
};

export const getAvgPricesText = (type?: PricesViewType) => {
    switch (type) {
        case PricesViewType.FLATS:
            return "średnie ceny mieszkań";
        case PricesViewType.HOUSES:
            return "średnie ceny domów";
        case PricesViewType.ALL:
            return "średnie ceny nieruchomości";
        default:
            return "średnie ceny";
    }
};
